import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { TopPanelComponent } from '../..';
import { PlannerEcsSystem } from './System';
/**
 * To be able to stack two frames this system handles removing the
 * legs on the guest (top) frame and the top on the host (bottom) frame.
 */
export class StackableFrameHandlerSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'StackableFrameHandlerSystem', ComponentIds.MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID);
        this.placementService = coreApi.placementService;
    }
    onAdd(entity, newComponent) {
        if (!newComponent.snap) {
            return;
        }
        this.removeLegsAndTops(newComponent.snap);
    }
    onUpdate() { }
    onRemove() { }
    /**
     * Checks it the host and guest are both frames, and if the snap action
     * tries to connect frame to frame, i.e stacking. If true it will remove the legs
     * on the guest frame and top on the guest frame to be able to stack
     */
    removeLegsAndTops(snapActionCandidate) {
        const host = snapActionCandidate.host;
        const guest = snapActionCandidate.guest;
        if (this.isFrame(host) &&
            this.isFrame(guest) &&
            this.isDragged(guest) &&
            this.isTryingToStack(snapActionCandidate)) {
            const legs = HierarchyUtils.filterInHierarchy(guest, e => e.hasComponent(ComponentIds.LEG_COMPONENT_ID));
            const top = HierarchyUtils.children(host).filter(entity => entity.hasComponent(TopPanelComponent.id));
            this.coreApi.entities.deleteMultiple([...legs, ...top]);
        }
    }
    /**
     *
     * @returns true if entity is a frame
     */
    isFrame(entity) {
        return entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID);
    }
    /**
     *
     * @returns true if entity is currently beeing dragged
     */
    isDragged(entity) {
        return entity.hasComponent(ComponentIds.IS_DRAGGED_COMPONENT_ID);
    }
    /**
     *
     * @returns true if the snap action tries to connect by stacking
     */
    isTryingToStack(snapActionCandidate) {
        return (snapActionCandidate.guestConnector.key.startsWith('bottom-guest-stacking') &&
            snapActionCandidate.hostConnector.key.startsWith('stacking-host'));
    }
}
//# sourceMappingURL=StackableFrameHandlerSystem.js.map